import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { iMessageAttachment } from '@/types/common/models'
import MessageImage from '@/components/chat/MessageImage.vue'
import MessageFile from '@/components/chat/MessageFile.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageAttachment',
  props: {
    attachment: {},
    path: {}
  },
  emits: ['load'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isPreview = computed(() => props.attachment.mime === 'image/jpeg' || props.attachment.mime === 'image/png')
const src = computed(() => `files/${props.path}/${props.attachment.filename}`)

return (_ctx: any,_cache: any) => {
  return (isPreview.value)
    ? (_openBlock(), _createBlock(MessageImage, {
        key: 0,
        src: src.value,
        title: _ctx.attachment.title,
        onLoad: _cache[0] || (_cache[0] = ($event: any) => (emit('load')))
      }, null, 8, ["src", "title"]))
    : (_openBlock(), _createBlock(MessageFile, {
        key: 1,
        src: src.value,
        title: _ctx.attachment.title
      }, null, 8, ["src", "title"]))
}
}

})